import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "@/hooks/use-toast";

const HASH_ERROR_TRANSLATIONS: Record<string, string> = {
  otp_expired: "Link aktywacyjny wygasł lub został już użyty. Zaloguj się lub zarejestruj ponownie.",
  access_denied: "Odmowa dostępu. Spróbuj zalogować się ponownie.",
};

/**
 * Detects Supabase auth error fragments in the URL hash
 * (e.g. /#error=access_denied&error_code=otp_expired&...)
 * and redirects to /auth with a Polish toast message.
 */
export function AuthHashHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash || !hash.includes("error=")) return;

    const params = new URLSearchParams(hash.slice(1));
    const errorCode = params.get("error_code");

    if (errorCode) {
      const message =
        HASH_ERROR_TRANSLATIONS[errorCode] ??
        "Wystąpił błąd z linkiem. Spróbuj zalogować się ponownie.";

      // Clear the hash before navigating
      window.history.replaceState(null, "", window.location.pathname);

      toast({
        title: "Link wygasł",
        description: message,
        variant: "destructive",
      });

      navigate("/auth", { replace: true });
    }
  }, [location]);

  return null;
}
